import React from 'react';
import { Row, Typography } from 'antd';
import { StepFormProps } from '../../types/types';
import hourglass from "../../assets/images/hourglass-outline.svg";
import styles from "./reviewing.module.scss";

export const Reviewing: React.FC<StepFormProps> = ( props ) => {

    return (
        <Row justify='space-between' className={styles['reviewing']}>
          <img
            alt='Icon'
            src={hourglass}
          />
          <Typography>You will see more informatin once you will receive your indicative offer</Typography>
        </Row>
    );
  }
;
